// src/pages/History/20thCentury/WorldWarIIGo.jsx
import React from 'react';
import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history2/20th_Century_-_World_War_II.png';

function HistoryPageWorldWarIIGo() {
  return (
    <QuizPage
      title="History: World War II"
      subTopic="World War II"
      backgroundImage={historyImage}
      returnPath="/History-World-War-II"
    />
  );
}

export default HistoryPageWorldWarIIGo;
